import { render, staticRenderFns } from "./SavedRoutes.vue?vue&type=template&id=1978831f&scoped=true"
import script from "./SavedRoutes.vue?vue&type=script&lang=js"
export * from "./SavedRoutes.vue?vue&type=script&lang=js"
import style0 from "./SavedRoutes.vue?vue&type=style&index=0&id=1978831f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1978831f",
  null
  
)

export default component.exports